<template>
  <div class='app-div'>
    <router-view/>
  </div>
</template>

<script>
import Header from "./components/Header";
import Main from "./components/Main";
export default {
  name: "app",
  components: {
    Header
  }
};
</script>

<style>
.app-div {
  width: 100vw;
  height: 100vh;
}
/* :root {
  --primary-color: #fff1ff;
} */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body {
  background: var(--primary-color);
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  line-height: 1.6;
}
a {
  color: #fff;
  text-decoration: none;
}
ul {
  list-style: none;
}
/* .body-bg-no-image {
  background: var(--primary-color);
}
.body-bg-image {
  background: var(--primary-color) url("./assets/overwatch/ashe.png") no-repeat top center;
  background-size: 60%;
} */
.container {
  max-width: 960px;
  margin: 1rem auto;
  overflow: auto;
  padding: 0 2rem;
}
.form-group {
  margin: 1rem 0;
}
.form-group label {
  color: #fff;
}
.search {
  background: rgba(0, 0, 0, 0.65);
  border: 4px darkgray solid;
  border-radius: 3px;
  margin-top: 1rem;
  padding: 2rem;
  /*                                                             */
  width: 50%;
  margin: auto;
  /*                                                             */
}

.search h1 {
  color: #fff;
}
input,
select,
textarea {
  display: block;
  width: 100%;
  padding: 0.4rem;
  font-size: 1.2rem;
  border: 1px solid #ccc;
}
.btn {
  display: inline-block;
  background: limegreen;
  color: #000000;
  padding: 0.4rem 1.3rem;
  border: none;
  cursor: pointer;
  outline: none;
  margin-top: 1rem;
  transition: all .5s ease-in-out;
}
.btn:hover{
  background: rgb(70, 248, 70);
}
@media (max-width: 700px) {
  body {
    background: var(--primary-color);
  }
}
</style>
